import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPlan: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"plan, process, connect, path"} maskId="square-filled-radius-0-stroke-1-IconPlan"><path d="M21 10H14V7H8.21484C6.88411 7.00026 6.47516 8.80372 7.67578 9.37793L16.7559 13.7197C18.917 14.7533 18.1807 17.9997 15.7852 18H10V21H3V14H10V17H15.7852C17.1159 16.9997 17.5248 15.1963 16.3242 14.6221L7.24414 10.2803C5.08296 9.24666 5.81934 6.00026 8.21484 6H14V3H21V10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPlan;
